import { UserRolesDTO } from './user-roles-dto';
import { PageRowsResponseDTO } from './page-response-dto';

export interface ReadUserRolesResponseDTO extends PageRowsResponseDTO<UserRolesDTO> {
    userRoles?: UserRolesDTO[];
}
